//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,countDownTimeFunc,toCopy} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import { Dialog,Toast } from 'vant';

export default {
  name: "qualityAllOrder",
  components: {
    footerNav
  },
  data() {
    return {
      value:'',
      toCopy,
      searchValue:'',
      loading:false,
      finished:false,
      refreshing:false,
      allQualityOrderList:[]
    }
  },
  created() {
  },
  mounted() {
  },
  updated() {
    document.scrollingElement.scrollTop = 0
  },
  methods: {
    onSearch(){
      this.allQualityOrderList = [];
      this.onLoad()
    },
    onLoad() {
      // getSendOrderList
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      var params = {
        'searchValue':this.searchValue,
        "qualityOrderType":2,
        "start":this.allQualityOrderList.length,
        "size":10,
        "orderRules":[{"orderKey":"recTime","desc":true},{"orderKey":"qualityOrderId","desc":true}],
        "desc":true
      }
      axiosApi.queryQualityOrderList(params).then(response => {
        if(response.content&&response.content.list&&response.content.list.length>0){
          response.content.list.forEach((item)=>{
            var channelStr = '';
            if(item.firstDeptName){
              channelStr += item.firstDeptName
            }
            if(item.secondDeptName){
              channelStr += '/'+item.secondDeptName
            }
            item.channelStr = channelStr
            if(item.isStockIn==1){
              item.isStockInStr = '是'
            }
            if(item.isStockIn==0){
              item.isStockInStr = '否'
            }
            if(item.isRedone==1){
              item.isRedoneStr = '是'
            }
            if(item.isRedone==0){
              item.isRedoneStr = '否'
            }
          })
          this.allQualityOrderList = this.allQualityOrderList.concat(response.content.list)
        }
        this.loading = false;
        this.refreshing = false;
        if(this.allQualityOrderList.length==response.content.total){
          this.finished = true;
        }
      })
    },
    toAll(qualityOrderId){
      this.$router.push({name:'allQualityDetail',query:{qualityOrderId:qualityOrderId}})
    },
    toDetail(){
      this.$router.push({name:'qualityOrderDetail'})
    },
    clickBtn(){
      Dialog.confirm({
        title: '提示',
        message: '确认进行此操作',
      })
        .then(() => {
          Toast.success('成功');

        })
        .catch(() => {
          Toast.fail('已取消');
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityAllOrder/index.vue